import React, { useEffect, useState } from "react";
import "./termsOfUse.scss";
import Icon from "../components/icon";
import * as Dimmer from "../components/dimmer";
import { Toast } from "ratel-ui";
import { http } from "../../core/Api";
import moment from "moment";

function TermsOfUse({ match }) {
  const [terms, setTerms] = useState();
  const [date, setDate] = useState();
  const [loading, setLoading] = useState(true);

  const { params } = match;

  async function fetchTermsOfUse() {
    http(`api/backend/v2/management/terms/${params.id}`, "GET")
      .then(response => {
        if (response.urlTermsOfUse) {
          setDate(response.createdAt);
          fetchJson(response.urlTermsOfUse);
        } else {
          Toast.error("Houve um erro ao carregar os dados! Recarregue a página.");
        }
      })
      .catch(() => {
        Toast.error("Houve um erro ao carregar os dados! Recarregue a página.");
      });
  }

  async function fetchJson(json) {
    let response = await fetch(json);
    response = await response.json();
    setTerms(response);
    setLoading(false);
  }

  useEffect(() => {
    fetchTermsOfUse();
  }, []);

  function renderItem(it, field, x) {
    if (!it) {
      return "";
    }
    const isString = typeof it[field] === "string";
    return isString ? it[field] : it[field] && it[field][x] ? it[field][x] : "";
  }

  return (
    <div className="terms-of-use-body">
      {loading && <Loading />}
      {terms && (
        <div className="terms-of-use">
          <div className="terms-of-use-content">
            <span className="terms-of-use-supertitle">{terms.title}</span>
            <span className="terms-of-use-subtitle">Publicado em: {moment(date).format("DD/MM/YYYY HH:mm:ss")}</span>
            <span className="terms-of-use-subtitle">{terms.subtitle}</span>
            <span className="terms-of-use-primarytitle">{terms.primarytitle}</span>
            <span className="terms-of-use-document-subtitle">{terms.documentSubtitle}</span>

            <div className="terms-of-use-itens">
              <div className="terms-of-use-iten">
                <span>
                  {renderItem(terms.resume[0].item, "text", "1")}
                  <b>{renderItem(terms.resume[0].item, "bold", "1")}</b>
                  {renderItem(terms.resume[0].item, "text", "2")}
                </span>
              </div>
              <div className="terms-of-use-iten">
                <Icon icon="buy" width={32} height={32} />
                <span>
                  {renderItem(terms.resume[1].item, "bold")}
                  {renderItem(terms.resume[1].item, "text")}
                </span>
              </div>
              <div className="terms-of-use-iten">
                <Icon icon="checkTrace" width={32} height={32} />
                <span>
                  <b>{renderItem(terms.resume[2].item, "bold")}</b>
                  {renderItem(terms.resume[2].item, "text")}
                </span>
              </div>
              <div className="terms-of-use-iten">
                <Icon icon="userXl" width={32} height={32} />
                <span>
                  {renderItem(terms.resume[3].item, "text")}
                  <b>{renderItem(terms.resume[3].item, "bold")}</b>
                </span>
              </div>
              <div className="terms-of-use-iten">
                <Icon icon="clockmd" width={32} height={32} />

                {renderItem(terms.resume[4].item, "bold") === " seguras e bem armazenadas" ? (
                  <span>
                    {renderItem(terms.resume[4].item, "text")}
                    <b>{renderItem(terms.resume[4].item, "bold")}</b>
                  </span>
                ) : (
                  <span>
                    <b>{renderItem(terms.resume[4].item, "bold")}</b>
                    {renderItem(terms.resume[4].item, "text")}
                    <a href={`mailto:${renderItem(terms.resume[4].item, "mail")}`}>
                      {" "}
                      {renderItem(terms.resume[4].item, "mail")}
                    </a>
                    .
                  </span>
                )}
              </div>
              <div className="terms-of-use-iten">
                <Icon icon="lockerLarge" width={32} height={32} />
                <span>
                  {renderItem(terms.resume[5].item, "text", "1")}
                  {renderItem(terms.resume[5].item, "bold", "1")}
                  <b>{renderItem(terms.resume[5].item, "text", "2")}</b>
                  <b>{renderItem(terms.resume[5].item, "bold", "2")}</b>
                </span>
              </div>
              <div className="terms-of-use-iten">
                <Icon icon="cart" width={32} height={32} />
                <span>
                  {renderItem(terms.resume[6].item, "text", "1")}
                  <b>{renderItem(terms.resume[6].item, "bold", "1")}</b>
                  {renderItem(terms.resume[6].item, "text", "2")}
                  <b>{renderItem(terms.resume[6].item, "bold", "2")}</b>
                </span>
              </div>
              <div className="terms-of-use-iten">
                <span>
                  <b>{renderItem(terms.resume[7] && terms.resume[7].item, "bold", "1")}</b>
                </span>
              </div>
            </div>

            {/* <span className="terms-of-use-info">{terms.info}</span> */}

            <div className="terms-document" dangerouslySetInnerHTML={{ __html: terms.content }} />
          </div>
        </div>
      )}
    </div>
  );
}

const Loading = () => (
  <div className="terms-of-use">
    <div className="terms-of-use-content">
      <Dimmer.Text width="80%" />
      <Dimmer.Text width="60%" />
      <Dimmer.Text width="80%" />
      <Dimmer.Text width="60%" />
      <Dimmer.Text width="60%" />
      <Dimmer.Text width="40%" />
      <Dimmer.Text width="80%" />
      <Dimmer.Text width="40%" />
      <Dimmer.Text width="40%" />
      <Dimmer.Text width="40%" />
      <Dimmer.Text width="60%" />
      <Dimmer.Text width="80%" />
      <Dimmer.Text width="80%" />
      <Dimmer.Text width="80%" />
      <Dimmer.Text width="80%" />
    </div>
  </div>
);

export default TermsOfUse;
